// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import React from 'react'
import { bool, func, number, string } from 'prop-types'
import DeleteAttachment from './DeleteAttachment'

const AttachmentItem = props => {
  const {
    canDeleteAttachment,
    commentFileId,
    deleteAttachment,
    fileName,
    fileUrl,
    idRoot,
    removeSingleAttachmentFromComment,
  } = props

  return (
    <li className={'display-flex'}>
      <a
        className={'display-block flex-1 margin-right-auto'}
        href={fileUrl}
        id={idRoot}
        rel={'noopener noreferrer'}
        target={'_blank'}
        title={fileName}>
        {fileName}
      </a>
      {
        canDeleteAttachment &&
        <DeleteAttachment
          deleteAttachment={deleteAttachment}
          commentFileId={commentFileId}
          idRoot={`${idRoot}-delete`}
          removeSingleAttachmentFromComment={removeSingleAttachmentFromComment} />
      }
    </li>
  )
}

AttachmentItem.propTypes = {
  canDeleteAttachment: bool.isRequired,
  commentFileId: number.isRequired,
  deleteAttachment: func.isRequired,
  fileName: string.isRequired,
  fileUrl: string.isRequired,
  idRoot: string.isRequired,
  removeSingleAttachmentFromComment: func.isRequired,
}

export default AttachmentItem
